import React from 'react'
import { Table, Anchor, Badge, Menu, ActionIcon } from '@mantine/core'
import { IconDotsVertical, IconTrash, IconPencil } from '@tabler/icons-react' 

const ActionMenu = ({ handleAction, detail }) => {
  return (
    <Menu width={200} position="bottom-end" withArrow arrowPosition="center">
      <Menu.Target>
        <ActionIcon ml={8} pt={6} variant='transparent' size='xs'>
          <IconDotsVertical stroke={1.5} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          leftSection={<IconPencil stroke={1.5} size={14} />}
          onClick={() => handleAction('edit')}
          fw='600'
          fz={11}
        >
          Edit Supplier
        </Menu.Item>
        <Menu.Item
          color='red'
          leftSection={<IconTrash stroke={1.5} size={14} />}
          onClick={() => handleAction('delete')}
          fw='600'
          fz={11}
        >
          Delete
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}

const TableSupplier = ({ label, data, actionMethod }) => {

  const mappingTableHead = (data) => data.map((val, index) => {
    return (<Table.Th key={index} width={val.width !== 'auto' ? val.width : ''}>{val.label}</Table.Th>)
  })

  const mappingDataTable = (data) => data.map((val, index) => {
    return (
      <Table.Tr key={index}>
        <Table.Td>{val.id}</Table.Td>
        <Table.Td>{val.name}</Table.Td>
        <Table.Td>{val.country !== null ? val.country.name : '-'}</Table.Td>
        <Table.Td>{val.address !== null ? val.address : '-'}</Table.Td>
        <Table.Td>{val.province !== null ? val.province.name : '-'}</Table.Td>
        <Table.Td>{val.city !== null ? val.city.name : '-'}</Table.Td>
        <Table.Td>{val.district !== null ? val.district.name : '-'}</Table.Td>
        <Table.Td>{val.total_product}</Table.Td>
        <Table.Td>
          <Anchor fz={13} href={val.website} underline='hover' c='blue' target='_blank'>{val.website}</Anchor>
        </Table.Td>
        <Table.Td>
          <Badge variant="light" color={val.active ? 'teal' : 'red'} tt='capitalize' fz={12} fw='500'>{val.active ? 'Active' : 'Inactive'}</Badge>
        </Table.Td>
        <Table.Td><ActionMenu handleAction={(type) => actionMethod(val, type)} /></Table.Td>
      </Table.Tr>
    )
  })

  return (
    <Table.ScrollContainer minWidth={1366} type='native'>
      <Table highlightOnHover withTableBorder style={{ fontSize: '13px' }}>
        <Table.Thead style={{ backgroundColor: '#eeefef' }}>
          <Table.Tr>
            {mappingTableHead(label)}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody style={{ verticalAlign: 'top' }}>
          {mappingDataTable(data)}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  )
}

export default TableSupplier